module.exports = __webpack_public_path__ + "img/pdf-icon.ab4a30e0.png";